var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n<tr>\n    <th>Name</th>\n    <th class="col-actions">Actions</th>\n</tr>\n</thead>\n<tbody></tbody>';
}
return __p;
};
